var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    {
      staticClass: "white elevation-1",
      staticStyle: { "border-radius": "5px" },
      attrs: { fluid: "" }
    },
    [
      _c(
        "v-row",
        { staticClass: "pl-3" },
        [
          _c("v-col", { attrs: { cols: "10" } }, [
            _c("h3", { staticClass: "overline" }, [
              _c("strong", [
                _vm._v("Registros de Control Ambiental " + _vm._s(_vm.name))
              ])
            ])
          ]),
          _c(
            "v-col",
            { staticClass: "pt-0 mt-0", attrs: { cols: "2" } },
            [
              _c(
                "v-row",
                [
                  _c(
                    "v-tooltip",
                    {
                      attrs: {
                        bottom: "",
                        color: _vm.temperatureParameterSelected
                          ? "#603E99"
                          : "#D3D3D3"
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "activator",
                          fn: function(ref) {
                            var on = ref.on
                            return [
                              _c(
                                "v-btn",
                                _vm._g(
                                  {
                                    attrs: {
                                      icon: "",
                                      value: "Temperatura",
                                      color: _vm.temperatureParameterSelected
                                        ? "#603E99"
                                        : "#D3D3D3"
                                    },
                                    on: {
                                      click: function($event) {
                                        _vm.temperatureParameterSelected = true
                                      }
                                    }
                                  },
                                  on
                                ),
                                [
                                  _c("v-icon", [_vm._v("mdi-thermometer-high")])
                                ],
                                1
                              )
                            ]
                          }
                        }
                      ])
                    },
                    [_c("span", [_vm._v("Temperatura")])]
                  ),
                  _c(
                    "v-tooltip",
                    {
                      attrs: {
                        bottom: "",
                        color: _vm.temperatureParameterSelected
                          ? "#D3D3D3"
                          : "#94CA4E"
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "activator",
                          fn: function(ref) {
                            var on = ref.on
                            return [
                              _c(
                                "v-btn",
                                _vm._g(
                                  {
                                    attrs: {
                                      icon: "",
                                      value: "Humedad",
                                      color: _vm.temperatureParameterSelected
                                        ? "#D3D3D3"
                                        : "#94CA4E"
                                    },
                                    on: {
                                      click: function($event) {
                                        _vm.temperatureParameterSelected = !_vm.temperatureParameterSelected
                                      }
                                    }
                                  },
                                  on
                                ),
                                [_c("v-icon", [_vm._v("mdi-water-outline")])],
                                1
                              )
                            ]
                          }
                        }
                      ])
                    },
                    [_c("span", [_vm._v("Humedad")])]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "span",
        { staticClass: "d-flex justify-center fill-height" },
        [
          _c("apexchart", {
            staticClass: "dashboard-chart",
            attrs: {
              type: "area",
              options: _vm.temperatureAndHumidityOptions,
              series: _vm.temperatureParameterSelected
                ? _vm.temperatureOptions.series
                : _vm.humidityOptions.series
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }